import React, { useEffect, useState, FC } from 'react';
import { Avatar, Box, Text, VStack } from '@chakra-ui/react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { AuthService } from '~/store/ducks/Auth/services';
import { devices } from '~/styles/breakpoints';
import { colors } from '~/styles/colors';
import { useI18n } from '~/i18n';
import api from '~/services/api';

type MobileMenuProps = {
  open?: boolean;
};

interface RightNavProps {
  open?: boolean;
  userInfo: string;
}

const MobileMenu = styled.nav<MobileMenuProps>`
  flex-flow: column nowrap;
  background-color: ${colors.secondary};
  font-size: 2rem;
  position: fixed;
  transform: ${(props) => (props.open ? 'translateX(0)' : 'translateX(100%)')};
  top: 0;
  right: 0;
  height: 100vh;
  width: 300px;
  padding-top: 3.5rem;
  transition: transform 0.3s ease-in-out;
  z-index: 10;
  list-style: none;
  display: flex;

  .logged-info {
    margin: 15px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 50px;

    @media ${devices.tablet} {
      display: none;
    }

    .userinfo {
      font-size: 16px;
      font-weight: 400;
      color: white;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 250px;

      @media ${devices.tablet} {
        display: none;
      }
    }
  }

  li {
    padding: 0 15px;
    font-size: 16px;
    color: ${colors.white};
    padding-bottom: 1rem;

    a.selected,
    a:hover,
    a:focus {
      color: ${colors.white};
      font-weight: 600;

      @media ${devices.tablet} {
        color: ${colors.primary};
      }
    }
  }

  @media ${devices.tablet} {
    flex-flow: row nowrap;
    background-color: ${colors.white};
    top: auto;
    right: unset;
    height: initial;
    width: auto;
    padding-top: initial;
    transform: translateX(10px);
    position: relative;
    transition: none;

    ul {
      display: flex;
      flex-direction: row;
      align-items: center;

      li {
        padding: 0 15px;
        font-weight: 400;
        font-size: 16px;
        color: ${colors.gray200};
        display: block;

        &.logout {
          display: block;

          @media ${devices.tablet} {
            display: none;
          }
        }
      }
    }
  }
`;

const RightNav: FC<RightNavProps> = ({ open, userInfo }) => {
  const { pathname } = useLocation();
  const [menu, setMenu] = useState(pathname);
  const [canManageGuests, setCanManageGuests] = useState(false);
  const { t } = useI18n();

  useEffect(() => {
    if (!AuthService.isAuthenticated()) return;
    api.get('/v1/guest/compressor-access/permission')
      .then(() => setCanManageGuests(true))
      .catch(() => setCanManageGuests(false));
  }, []);

  return (
    <>
      <MobileMenu open={open}>
        <Box className="logged-info">
          <VStack align="start">
            <Avatar className="avatar" size="sm" bg={colors.gray100} />
            <Text className="userinfo"> {userInfo} </Text>
          </VStack>
        </Box>
        <ul>
          <li>
            <Link
              to="/projects"
              className={menu === '/projects' ? 'selected' : ''}
              onClick={() => setMenu('/projects')}
            >
              {t('Projetos')}
            </Link>
          </li>
          <li>
            <Link
              to="/comparison"
              className={menu === '/comparison' ? 'selected' : ''}
              onClick={() => setMenu('/comparison')}
            >
              {t('Produtos')}
            </Link>
          </li>
          {canManageGuests && (
            <li>
              <Link
                to="/guest-users"
                className={menu === '/guest-users' ? 'selected' : ''}
                onClick={() => setMenu('/guest-users')}
              >
                {t('Usuários Guest')}
              </Link>
            </li>
          )}
          {AuthService.isAuthenticated() && (
            <li className="logout">
              <Link to={{ pathname: '/logout', state: { isLogin: false } }}>{t('Sair')}</Link>
            </li>
          )}
        </ul>
      </MobileMenu>
    </>
  );
};

export default RightNav;
